module.exports = __webpack_public_path__ + "static/media/spotify_logo.8e3610fa.png";